/* eslint-disable @typescript-eslint/default-param-last */
import { fromJS } from 'immutable';
import { SET_ACIS_INDEX } from '../actions/safetyDashboard.action';

const INITIAL_STATE = fromJS({});

const safetyDashboardReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_ACIS_INDEX:
      return state.set('acisIndex', fromJS(action.index));
    default:
      return state;
  }
};

export default safetyDashboardReducer;
